import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {useToast} from "../../../../utils/contexts/toast-context";
import {CustomAxiosError} from "../../../../logics/api_config";
import Loading from "../../../ui/Loading";
import {ICurrency} from "../../../../utils/interfaces/my_documents/ICurrency";
import useApiGetCurrency from "./api-hooks/useApiGetCurrency";
import {Box, Popover, TextField} from "@mui/material";
import MuiAutocomplete from "../../../ui/mui/mui-input/MuiAutoComplete";
import {useTheme} from "@mui/material/styles";
import useApiGetCurrencyDetailed from "./api-hooks/useApiGetCurrencyDetailed";


interface Props {
    obj: ICurrency | undefined,
    onChange: (obj: ICurrency | undefined) => void,
    className: string,
    label?: string,
    clearable?: boolean
    required?: boolean
}

const CurrencySelect = ({obj: initialObj, onChange, label, clearable, required, ...props}: Props) => {
    const {displayError, displayMessage} = useToast()
    const {t} = useTranslation();
    const theme = useTheme();
    const [objs, setObjs] = useState<ICurrency[]>([]);
    const [obj, setObj] = useState<ICurrency | undefined>(initialObj)


    const {
        data,
        isLoading,
        error,
    } = useApiGetCurrency();
    if (error) {
        const axiosError = error as CustomAxiosError;
        displayError(axiosError.response.data.detail);
    }


    useEffect(() => {
        if (data) {
            setObjs(data);
        }
    }, [data]);

    useEffect(() => {
        setObj(initialObj);
    }, [initialObj]);


    const handleOnChange = (event: React.SyntheticEvent, newValue: ICurrency | null) => {
        if (newValue) {
            onChange(newValue);
        } else {
            onChange(undefined);
        }

    };

    const {
        data: detailedObj,
    } = useApiGetCurrencyDetailed(obj?.id);

    const {
        data: defaultObj,
    } = useApiGetCurrencyDetailed(1);

    useEffect(() => {
        if (obj) {
            onChange(obj);
        } else {
            onChange(defaultObj);
        }
    }, [obj]);


    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <>
                    <Box sx={{display: 'flex', alignItems: 'center', width: '100%'}}>

                        <MuiAutocomplete
                            id="curreny-select"
                            options={objs}
                            getOptionLabel={(option) => option.name}
                            value={detailedObj ? detailedObj : defaultObj ? defaultObj : null}
                            onChange={handleOnChange}
                            isOptionEqualToValue={(option, value) => option.id === value?.id && option.name === value?.name}
                            renderInput={(params) => (
                                <TextField
                                    sx={{textTransform: 'capitalize'}}
                                    {...params}
                                    label={t(label ? label : '') || t('currency')}
                                    required={required}
                                />
                            )}
                        />
                    </Box>

                </>
            )}
        </>
    );
}

export default CurrencySelect;